import HttpService from "./HttpService";
const API_URL = "/aptitude-test";

const AptitudeTestService = {
  fetch: async () => {
    try {
      const response = await HttpService.get(API_URL);
      return response.data;
    } catch (error) {
      console.error("Error fetching aptitude tests:", error);
      throw error;
    }
  },
  async fetchPaginated(pageConfig,parameters) {
    const pageConfigParams = new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.post(
        `${API_URL}-paginated?${pageConfigParams}`, parameters
      );
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  add: async (data) => {
    try {
      const response = await HttpService.post(API_URL, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          // Add any other headers if required
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error adding aptitude test:", error);
      throw error;
    }
  },

  edit: async (id) => {
    try {
      const response = await HttpService.get(`${API_URL}/${id}/edit`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  view: async (id) => {
    try {
      const response = await HttpService.get(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, data) => {
    console.log(data);
    data["_method"] = "PUT";
    try {
      const response = await HttpService.post(`${API_URL}/${id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating aptitude test:", error);
      throw error;
    }
  },
  // async update(id, data) {
  //   // data["_method"] = "PUT";
  //   try {
  //     const response = await HttpService.put(
  //       `${API_URL}/${id}`,
  //       data,
  //       {
  // headers: {
  //   "Content-Type": "multipart/form-data",
  // },
  //       }
  //     );
  //     return response.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // },

  delete: async (id) => {
    try {
      const response = await HttpService.delete(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting aptitude test:", error);
      throw error;
    }
  },

  attempt: async (id, data) => {
    // data["_method"] = "PUT";
    try {
      const response = await HttpService.post(`/test-link/${id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error attempting test:", error);
      throw error;
    }
  },

  getTests: async (jobId) => {
    try {
      const response = await HttpService.get(`/test-view`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getRecommendedTests: async (interviewId) => {
    try {
      const response = await HttpService.get(
        `/test-recommended/${interviewId}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  sendTest: async (jobId, applierId, testId) => {
    try {
      const response = await HttpService.get(
        `/test-send/${applierId}/${testId}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getTestResults: async (applierId) => {
    try {
      const response = await HttpService.get(`/test-result/${applierId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchResults: async () => {
    try {
      const response = await HttpService.get("/candidates-test-list");
      return response.data;
    } catch (error) {
      console.error("Error fetching test results:", error);
      throw error;
    }
  },
  async fetchPaginatedResults(pageConfig, parameters) {
    const pageConfigParams = new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.post(
        `/candidates-test-list-paginated?${pageConfigParams}`, parameters
      );
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
};

export default AptitudeTestService;
